import React from "react";
import type { UseFormRegister } from "react-hook-form";
import { Box } from "../../design-system";
import TextField from "../../design-system/TextField";
import { EDIT_PROFILE_MODAL } from "../constants/accountText";
import type { EditProfileFormData } from "../../../types/user";

interface EditProfileFormProps {
  register: UseFormRegister<EditProfileFormData>;
  onSubmit: React.FormEventHandler<HTMLElement>;
}

const EditProfileForm = ({ register, onSubmit }: EditProfileFormProps) => (
  <Box
    component="form"
    onSubmit={onSubmit}
    sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
  >
    <TextField
      id="edit-profile-full-name"
      fullWidth
      placeholder={EDIT_PROFILE_MODAL.INPUT_PLACEHOLDER}
      autoComplete="off"
      {...register("full_name")}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: "rgba(141, 153, 183, 0.15)",
          borderRadius: "4px",
          height: "48px",
          padding: "0",
          fontSize: "14px",
          fontWeight: 300,
          "& fieldset": { border: "none" },
          "&:hover fieldset": { border: "none" },
          "&.Mui-focused fieldset": { border: "none" },
        },
        "& .MuiOutlinedInput-input": { padding: "8px 16px" },
      }}
    />
  </Box>
);

export default EditProfileForm;
